import PresenterModeIcon from '@atlaskit/icon/core/presenter-mode';
import * as React from 'react';

export function SvgCallToAction() {
  return <PresenterModeIcon label="" testId="ads-refreshed-icon" />;
}
